<script lang="ts" setup>

</script>

<template>
  <div class="space-y-2">
    <p>
      Официальный сайт Банка России
      <a href="https://cbr.ru/" target="_blank" class="text-blue-300 hover:underline">
        https://cbr.ru/
      </a>
    </p>
    <p>
      Реестр Финансовых организаций
      <a
        href="https://cbr.ru/microfinance/registry/"
        target="_blank"
        class="text-blue-300 hover:underline"
      >
        https://cbr.ru/microfinance/registry/
      </a>
    </p>
    <p>
      Страница интернет-приемной Банка России
      <a
        href="https://cbr.ru/Reception/"
        target="_blank"
        class="text-blue-300 hover:underline"
      >
        https://cbr.ru/Reception/
      </a>
    </p>
    <p>
      Потребитель вправе направить обращение финансовому уполномоченному в соответствии со статьями 15-19 Федерального закона от 4 июня 2018 года N 123-ФЗ "Об уполномоченном по правам потребителей финансовых услуг". Местонахождения и почтовый адрес уполномоченного: 119017, г. Москва, Старомонетный пер., дом 3. Телефон: 8 (800) 200-00-10.

      Адрес официального сайта: <a href="https://finombudsman.ru/" target="_blank" class="text-blue-300 hover:underline">https://finombudsman.ru/</a>
    </p>
  </div>
</template>

<style>

</style>
